/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { PaymentMethodStatus } from "./PaymentMethodStatus";
import { Bundle } from "./Bundle";
import * as t from "io-ts";

/**
 * Calculate fee response
 */

/**
 * Brand assets map associated to the selected payment method
 */

// additional attributes

export const CalculateFeeResponseBrandAssets = t.record(
  t.string,

  t.string,

  "CalculateFeeResponseBrandAssets"
);

export type CalculateFeeResponseBrandAssets = t.TypeOf<
  typeof CalculateFeeResponseBrandAssets
>;

// required attributes
const CalculateFeeResponseR = t.interface({
  paymentMethodName: t.string,

  paymentMethodDescription: t.string,

  paymentMethodStatus: PaymentMethodStatus,

  bundles: t.readonlyArray(Bundle, "array of Bundle"),

  asset: t.string
});

// optional attributes
const CalculateFeeResponseO = t.partial({
  belowThreshold: t.boolean,

  brandAssets: CalculateFeeResponseBrandAssets
});

export const CalculateFeeResponse = t.intersection(
  [CalculateFeeResponseR, CalculateFeeResponseO],
  "CalculateFeeResponse"
);

export type CalculateFeeResponse = t.TypeOf<typeof CalculateFeeResponse>;
